module.exports = __webpack_public_path__ + "static/img/2015-05-23 11.57.58.ac7e12f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2015-05-23 11.57.58.jpg
// module id = 7fCz
// module chunks = 4